import { render, staticRenderFns } from "./StoreRoleDelete.vue?vue&type=template&id=66e95703&scoped=true&"
import script from "./StoreRoleDelete.vue?vue&type=script&lang=js&"
export * from "./StoreRoleDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e95703",
  null
  
)

export default component.exports